




























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Cid } from '@/types/_'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import QuantidadeProcedimentos from '@finx/web-repository/src/constants/QuantidadeProcedimentos'

@Component

export default class ComponentModalSolicitacaoCirurgiaCid extends Vue {
  cidLock: boolean = false
  inputSearch: string = ''
  searchMessage: any = {
    searchCid: false,
    listText: '',
  }

  get getCids() {
    return this.getSolicitacaoStore.cids
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get getShowModalCid() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showCid
  }

  set getShowModalCid(value: boolean) {
    this.getSolicitacaoStore.showModalCid(value)
  }

  get getCidsApi() {
    return this.getSolicitacaoStore.cidsApi
  }

  @Watch('getShowModalCid')
  onChangeGetShowModalCid(value) {
    setTimeout(() => {
      const input = document.querySelector('.cid-input input') as HTMLInputElement
      if (value) {
        input.focus()
      } else {
        input.value = ''
        input.blur()
        this.getInputSearch = ''
      }
    }, 100)
  }

  closeModalCid() {
    this.getSolicitacaoStore.showModalCid(false)
    return this.getSolicitacaoStore.cids
  }

  async addSelected(cid: Cid) {
    if (!this.cidLock) {
      this.cidLock = true
      EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.post })
      const request = await this.getSolicitacaoStore.postCid(cid)
      if (request.success) {
        this.getSolicitacaoStore.setCid(cid)
        await this.getSolicitacaoStore.removeCidApi(cid)
        this.searchMessage.listText = 'Todos os itens foram selecionados.'
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição', icon: 'warning', color: '#C62828' })
      }

      EventBus.$emit('clearLoadingRequest')
      this.cidLock = false
    }
  }

  async removeChip(cid: Cid) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.deleteMessage })
    const request = await this.getSolicitacaoStore.deleteCid(cid)

    if (request.success) {
      this.getSolicitacaoStore.removeCid(cid)
      this.getSolicitacaoStore.setCidApi(cid)
    }

    EventBus.$emit('clearLoadingRequest')
  }

  debounce = _.debounce(input => this.searchCid(input), 600)

  search() {
    if (this.getInputSearch.length === 0 || this.getInputSearch.length > 2) {
      this.debounce(this.getInputSearch)
    }
  }

  async searchCid(input) {
    this.searchMessage.listText = 'Buscando Cid...'
    this.searchMessage.searchCid = false

    await this.getSolicitacaoStore.getCidSearch(input)
    if (this.getCidsApi.length > 0) {
      this.searchMessage.listText = 'Não foi encontrado CID...'
    } else {
      this.searchMessage.listText = ''
    }
  }
}

